module.exports = __webpack_public_path__ + "img/BGR.89118080.svg";